import React from 'react';
import Image from '../../../basic/image'
import styled from "styled-components";
import CustomizedSwiper from '../../../basic/CustomizedSwiper'
import TranslateText from 'src/text/modal';

import Ассортимент from '../../../static/Большой_ассортимент.png'
import Регионы from '../../../static/Работа_с_регионами.png'
import РегионыУкраина from '../../../static/Работа_с_регионами_Украина.png';
import Доставка from '../../../static/Доставка.png'
import CurrentLanguageContext from 'src/context/currentLanguageContext';


const CardDiv = styled.div`
  padding: 20px;
  text-align: center;
  height: inherit;
`

function Card({text, image}) {
  return (
    <CardDiv>
      <Image
        src={image}
        height={115}
        containerStyle={{
          display: 'inline-block',
        }}
      />
      <br/>
      <div
        style={{
          marginTop: 10,
          display: 'inline-block',
          verticalAlign: 'middle',
          textTransform: 'uppercase',
          color: '#173DB0',
        }}
        dangerouslySetInnerHTML={{'__html': text}}
      />
    </CardDiv>
  )
}

export default function mobile() {
  const translateStyles = {
    marginLeft: 20,
    marginRight: 20,
    height: 200,
    verticalAlign: 'top',
  };

  return (
    <CurrentLanguageContext.Consumer>
      {currentLanguage => {
        const list = [
          <TranslateText
            style={translateStyles}
            place="top"
            id="partners__large_assortment"
            controls={["bold"]}
            useHtml
            render={html => {
              return (
                <Card
                  text={html}
                  image={Ассортимент}
                />
              );
            }}
          />,
          (currentLanguage === 'ru' ?
            <TranslateText
              style={translateStyles}
              place="top"
              id="partners__regions"
              controls={["bold"]}
              useHtml
              render={html => {
                return (
                  <Card
                    text={html}
                    image={Регионы}
                  />
                );
              }}
            />
            :
            null
          ),
          <TranslateText
            style={translateStyles}
            place="top"
            id="partners__delivery"
            controls={["bold"]}
            useHtml
            render={html => {
              return (
                <Card
                  text={html}
                  image={Доставка}
                />
              );
            }}
          />,
        ].filter(Boolean);

        return <CustomizedSwiper list={list}/>;
      }}
    </CurrentLanguageContext.Consumer>
  )
}



// WEBPACK FOOTER //
// ./src/finwhale/common/opt-princip/Mobile.js